import React from "react";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

type DialogProps = {
  open: boolean;
  handleClose: () => void;
  handleConfirm: (props: EventCompletedProps) => void;
};

type CompletedField = keyof EventCompletedProps;

const FIELD_CONFIG: Array<{
  key: CompletedField;
  label: string;
  xs: number;
  autoFocus?: boolean;
}> = [
  {
    key: "attendance",
    label: "Hvor mange mødte op til infoaften?",
    xs: 12,
    autoFocus: true,
  },
  { key: "interviews", label: "Aftalte samtaler", xs: 6 },
  { key: "interviewsSport", label: "Samtaler Sport", xs: 6 },
  { key: "interviewsOutdoor", label: "Samtaler Friluft", xs: 6 },
  { key: "interviewsXOutdoor", label: "Samtaler X-Outdoor", xs: 6 },
  { key: "facebookInterested", label: "Facebook Interesserede", xs: 6 },
  { key: "facebookParticipants", label: "Facebook Deltagere", xs: 6 },
];

const INITIAL_VALUES: EventCompletedProps = {
  attendance: 0,
  interviews: 0,
  interviewsSport: 0,
  interviewsOutdoor: 0,
  interviewsXOutdoor: 0,
  facebookInterested: 0,
  facebookParticipants: 0,
};

const parseNumberInput = (value: string) => {
  const parsed = Number.parseInt(value, 10);

  return Number.isNaN(parsed) ? 0 : parsed;
};

const CompleteEventDialog: React.FC<DialogProps> = ({
  open,
  handleConfirm,
  handleClose,
}) => {
  const [values, setValues] = React.useState<EventCompletedProps>(INITIAL_VALUES);

  React.useEffect(() => {
    if (!open) {
      setValues(INITIAL_VALUES);
    }
  }, [open]);

  const handleValueChange = (key: CompletedField, rawValue: string) => {
    setValues((currentValues) => ({
      ...currentValues,
      [key]: parseNumberInput(rawValue),
    }));
  };

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">Marker som afviklet</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Hvis du markerer denne infoaften som afviklet vil det ikke længere
          være muligt at foretage ændringer.{" "}
          <strong>NB. ALLE EMAIL ADRESSER BLIVER SLETTET</strong>
        </DialogContentText>
        <Grid container>
          {FIELD_CONFIG.map(({ key, label, xs, autoFocus }) => (
            <Grid item xs={xs} key={key}>
              <TextField
                autoFocus={autoFocus}
                value={values[key]}
                onChange={(event) => handleValueChange(key, event.target.value)}
                margin="dense"
                label={label}
                type="number"
                fullWidth={xs === 12}
              />
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Annuller
        </Button>
        <Button
          variant="contained"
          onClick={() => handleConfirm(values)}
          color="secondary"
        >
          Afviklet
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default CompleteEventDialog;
